export default function getCompanyPlanStatus(companyStatus) {
  switch (companyStatus) {
    case 0: case 1: case 2: case 3: case 4:
      return 'Active'
    case 5: case 6: case 7:
      return 'Hold'
    case 8:
      return 'Inactive'
    default:
      return "-"
  }
}
